import React, { useState, useMemo, useEffect } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  FormControl,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ReactApexChart from "react-apexcharts";
import GrnReportModule from "./manufacturing/GrnReportModule";
import AgingAnalysisModule from "./manufacturing/AgingAnalysisModule";
import {
  DELETE_GROUPS_ERROR,
  DELETE_GROUPS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
  MANUFACTURING_DATA_ERROR,
  MANUFACTURING_DATA_LOADING,
  MANUFACTURING_DATA_SUCCESS,
} from "../../store/types/billTypes";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import { setBillReducer } from "../../store/actions/billActions";
import CoreIconButton from "../../core/inputs/CoreIconButton";

export default function ManufacturingInvoiceDashboard() {
  const TODAY = new Date();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);

  const data = useSelector((state) => state.bill.manufacturingDashboardData);
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);
  const deleteGroupSuccess = useSelector(
    (state) => state.bill.deleteGroupSuccess,
  );
  const deleteGroupError = useSelector((state) => state.bill.deleteGroupError);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      dispatch(
        setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
      );
    }
    if (groupDocsError) {
      alert("Internal error");
      dispatch(
        setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
      );
    }
  }, [groupDocsSuccess, groupDocsError]);

  useEffect(() => {
    if (deleteGroupSuccess) {
      getData();
      dispatch(
        setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false }),
      );
    }
    if (deleteGroupError) {
      alert("Internal error");
      dispatch(
        setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false }),
      );
    }
  }, [deleteGroupSuccess, deleteGroupError]);

  const getData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/api/manufacturing/data",
        {},
        {},
        MANUFACTURING_DATA_LOADING,
        MANUFACTURING_DATA_SUCCESS,
        MANUFACTURING_DATA_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const deleteGroups = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/groups/delete/all",
        {},
        {},
        null,
        DELETE_GROUPS_SUCCESS,
        DELETE_GROUPS_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        minHeight: "100vh",
        p: { xs: 2, md: 3 },
      }}
    >
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            fontSize: 14,
            minHeight: 54,
            minWidth: 500,
            textAlign: "left",
            alignItems: "flex-start",
          },
          "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: "3px 3px 0 0",
          },
        }}
      >
        <Tab
          label={
            <Box>
              <Typography variant="h5" fontWeight={800} letterSpacing={-0.5}>
                Executive Dashboard
              </Typography>
              <Typography variant="caption" color="text.secondary">
                As of{" "}
                {TODAY.toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </Typography>
            </Box>
          }
        />
        <Tab
          label={
            <Box>
              <Typography variant="h5" fontWeight={800} letterSpacing={-0.5}>
                Aging Dashboard
              </Typography>
              <Typography variant="caption" color="text.secondary">
                As of{" "}
                {TODAY.toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </Typography>
              <CoreIconButton onClick={groupData}>
                <Icon>sync</Icon>
              </CoreIconButton>
              <CoreIconButton onClick={deleteGroups}>
                <Icon>delete_all</Icon>
              </CoreIconButton>
            </Box>
          }
        />
      </Tabs>

      {tab === 0 && <GrnReportModule data={data} />}
      {tab === 1 && <AgingAnalysisModule data={data} />}

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        py={3}
      >
        <Typography variant="caption" color="text.disabled">
          Manufacturing Procurement Analytics · DocXplor Platform · Generated{" "}
          {TODAY.toLocaleDateString("en-IN")}
        </Typography>
      </Stack>
    </Box>
  );
}
